import { type Dir, isDir } from '../grid.ts';
import { assertLeaderMayAct, faceUnit } from '../round.ts';
import { InvalidCommand } from '../state.ts';
import type { CommandHandler } from './types.ts';

/** The leader faces `dir`. Free: the round does not end. Allowed while charging, not while asleep or stunned. */
export type TurnCommand = {
  readonly type: 'turn';
  readonly dir: Dir;
};

export const turn: CommandHandler<TurnCommand> = (_ctx, state, command) => {
  const leader = assertLeaderMayAct(state, 'turn');
  // Logs arrive as JSON, so the payload is checked at run time too.
  if (!isDir(command.dir)) throw new InvalidCommand('bad_direction', 'bad direction');
  return faceUnit(state, leader.id, command.dir);
};
